(function () {
  function init(root) {
    if (!root || root.dataset.ogcCommitmentsReady === 'true') return;
    root.dataset.ogcCommitmentsReady = 'true';

    var revealEls = root.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }

    root.querySelectorAll('.accordion .acc-head').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    var el = root.querySelector('[data-count-to]');
    if (el) {
      var target = parseInt(el.getAttribute('data-count-to'), 10) || 0;
      var from = 7046000000;
      var fmt = function (n) { return n.toLocaleString('en-US'); };
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        el.textContent = fmt(target);
      } else {
        var duration = 800;
        var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
        setTimeout(function () {
          el.textContent = fmt(from);
          var start = null;
          function step(ts) {
            if (start === null) start = ts;
            var p = Math.min((ts - start) / duration, 1);
            el.textContent = fmt(Math.round(from + ease(p) * (target - from)));
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        }, 220);
      }
    }

    if (window.lucide) window.lucide.createIcons();
    else window.addEventListener('load', function () {
      if (window.lucide) window.lucide.createIcons();
    }, { once: true });
  }

  function boot() {
    document.querySelectorAll('[data-ogc-commitments-page]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
